import React from 'react';
import {useDebtPaymentCreditCard} from '../../hooks/useDebtPaymentCreditCard';
import ProductDescription from '../ProductDescription';

const UpdatePaymentBansData = () => {
  const {paymentMethodBans} = useDebtPaymentCreditCard();

  return (
    <div>
      {paymentMethodBans?.paymentIssueBans?.map((ban) => (
        <div key={ban.banNumber} className='update-payment-bans-data-item'>
          <div className='bold s-title-small'> חשבון {ban.banNumber}</div>
          <ProductDescription
            productDescriptions={ban.productDescriptions}
            banNumber={ban.banNumber}
            className='s-title-small'
            tooltipIdPrefix='update-payment-bans'
          />
        </div>
      ))}
    </div>
  );
};

export default UpdatePaymentBansData;
